<template>
    <div class="modal-overlay">
        <div class="modal-content proc-modal-large">
            <h2>{{ props.tituloForm }}</h2>
            <h3>Selecione as Assinaturas Necessárias</h3>

            <div v-if="msgAlerta" class="alert-error">
                {{ msgAlerta }}
            </div>

            <div v-if="isLoading" class="margin-top10">
                Carregando...
            </div>

            <div v-else class="assinaturas-lista">
                <div
                    v-for="item in lsAssinaturas"
                    :key="item.idusuario"
                    class="assinatura-card"
                    :class="{ ativo: item.ckvincular === 'S' }"
                    @click="toggleAssinatura(item)"
                >
                    <div class="assinatura-info">
                        <div class="assinatura-nome">
                            {{ item.nmusuario }}
                        </div>

                        <div class="assinatura-perfil">
                            {{ item.nmperfil }}
                        </div>

                        <div class="assinatura-fone">
                            ☎ {{ item.celular || 'Telefone não informado' }}
                        </div>
                    </div>

                    <div class="assinatura-toggle-area" @click.stop>
                        <span class="assinatura-status">
                            {{ item.ckvincular === 'S' ? 'Assinar' : 'Não assinar' }}
                        </span>

                        <label class="switch">
                            <input
                                type="checkbox"
                                v-model="item.ckvincular"
                                true-value="S"
                                false-value="N"
                            />
                            <span class="slider"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="row-end margin-top10">
                <button type="button" class="btn-confirm" @click="salvarDados">
                    Confirmar
                </button>

                <button type="button" class="btn-cancel" @click="emit('close')">
                    Retornar
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const emit = defineEmits(['close', 'save']);

const props = defineProps({
    idEstabelecimento: {
        type: Number,
        default: 0
    },
    idSim: {
        type: Number,
        default: 0
    },
    idUsuario: {
        type: Number,
        default: 0
    },
    tituloForm: {
        type: String,
        default: 'Vincular Assinaturas'
    },
    referencia: {
        type: Object,
        default: () => ({
            titulo: '',
            tabela: '',
            id: 0,
            protocolo: ''
        })
    }
});

const isLoading = ref(false);
const msgAlerta = ref(null);
const lsAssinaturas = ref([]);

function toggleAssinatura(item) {
    item.ckvincular = item.ckvincular === 'S' ? 'N' : 'S';
}

async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const reqPerfil = await Api.genericPost('/dados/usuarios/lista/assinar', {
            idep: globalStore.idep,
            idsim: props.idSim,
            idestabelecimento: props.idEstabelecimento,
        });

        lsAssinaturas.value = (reqPerfil || []).map(item => ({
            ...item,
            ckvincular: props.idUsuario === item.idusuario ? 'S' : 'N'
        }));

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

async function salvarDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const selecionados = lsAssinaturas.value.filter(item =>
            item.ckvincular === 'S'
        );

        for (const item of selecionados) {
            await Api.genericPut('/cad/assinatura_pendencia', {
                idep: globalStore.idep,
                ref_titulo: props.referencia.titulo,
                ref_tabela: props.referencia.tabela,
                ref_id: props.referencia.id,
                ref_protocolo: props.referencia.protocolo,
                idusuarioass: item.idusuario,
                nmusuarioass: item.nmusuario,
                idlogin: globalStore.idlogin
            });
        }

        emit('save');
        emit('close');
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>

<style scoped>
.assinaturas-lista {
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-top: 12px;
}

.assinatura-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #f8f8f8;
    opacity: .62;
    cursor: pointer;
    transition: all .18s ease;
}

.assinatura-card:hover {
    opacity: .9;
    border-color: #b9cbc8;
    background: #f4faf9;
}

.assinatura-card.ativo {
    opacity: 1;
    border-color: #3a9b5f;
    background: #f1faf4;
    box-shadow: 0 0 0 1px rgba(58, 155, 95, .16);
}

.assinatura-info {
    flex: 1;
    min-width: 0;
    text-align: left;
}

.assinatura-nome {
    font-size: 15px;
    font-weight: 700;
    color: #13201f;
    line-height: 1.15;
    text-align: left;
}

.assinatura-perfil {
    margin-top: 2px;
    font-size: 12px;
    color: #5f6b69;
    text-transform: uppercase;
    text-align: left;
}

.assinatura-fone {
    margin-top: 3px;
    font-size: 12px;
    color: #687573;
    font-style: italic;
    text-align: left;
}

.assinatura-toggle-area {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    min-width: 130px;
    justify-content: flex-end;
}

.assinatura-status {
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    white-space: nowrap;
}

.assinatura-card.ativo .assinatura-status {
    color: #2e8b4f;
}

.switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex: 0 0 auto;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: #b8c0c5;
    transition: .2s;
    border-radius: 20px;
}

.slider:before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: white;
    transition: .2s;
    border-radius: 50%;
}

.switch input:checked + .slider {
    background-color: #2f9854;
}

.switch input:checked + .slider:before {
    transform: translateX(20px);
}

.alert-error {
    margin-top: 10px;
    padding: 10px;
    border-radius: 6px;
    background: #ffe6e6;
    color: #8a0000;
}

@media (max-width: 650px) {
    .assinatura-card {
        align-items: flex-start;
        flex-direction: column;
    }

    .assinatura-toggle-area {
        width: 100%;
        min-width: 0;
        justify-content: flex-end;
    }
}
</style>